// Variaveis extras das respostas prontas da RedHosting, preenchidas pelo
// editor junto com {{contact.name}} etc. Horario e datas sempre de Brasilia.
const TIME_ZONE = 'America/Sao_Paulo';
const DAY_MS = 24 * 60 * 60 * 1000;
// Mesmas regras de Refunds::FlowService no backend.
const ANALYSIS_DAYS = 3;
const APPROVAL_DAYS = 14;

const hourInBrazil = date =>
  Number(
    new Intl.DateTimeFormat('pt-BR', {
      hour: 'numeric',
      hourCycle: 'h23',
      timeZone: TIME_ZONE,
    }).format(date)
  );

export const greetingFor = (date = new Date()) => {
  const hour = hourInBrazil(date);
  if (hour >= 5 && hour < 12) return 'Bom dia';
  if (hour >= 12 && hour < 18) return 'Boa tarde';
  return 'Boa noite';
};

const dayMonth = date =>
  new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    timeZone: TIME_ZONE,
  }).format(date);

const weekday = date =>
  new Intl.DateTimeFormat('pt-BR', {
    weekday: 'long',
    timeZone: TIME_ZONE,
  }).format(date);

// 3 dias depois do pedido (abertura do ticket); ticket antigo conta de hoje.
export const analysisDeadline = (conversation, now = new Date()) => {
  const requestedAt = conversation?.created_at
    ? new Date(conversation.created_at * 1000)
    : now;
  const deadline = new Date(requestedAt.getTime() + ANALYSIS_DAYS * DAY_MS);
  return deadline < now
    ? new Date(now.getTime() + ANALYSIS_DAYS * DAY_MS)
    : deadline;
};

const refundDueDate = (conversation, now) => {
  const dueOn = conversation?.additional_attributes?.refund?.due_on;
  return dueOn
    ? new Date(`${dueOn}T12:00:00-03:00`)
    : new Date(now.getTime() + APPROVAL_DAYS * DAY_MS);
};

export const getRedhostingVariables = (conversation, now = new Date()) => {
  const deadline = analysisDeadline(conversation, now);
  return {
    saudacao: greetingFor(now),
    'reembolso.prazo_analise': `${weekday(deadline)} (${dayMonth(deadline)})`,
    'reembolso.data': dayMonth(refundDueDate(conversation, now)),
  };
};
